import { useEffect, useState, useRef } from 'react';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import {
    Button,
    ClickAwayListener,
    Grow,
    Paper,
    Popper,
    MenuItem,
    MenuList,
    Tooltip
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Constant from '@/common/constant/Constant';

const handleStatusTooltipMsg = (actionType, status = false) => {
    switch (actionType) {
        case Constant.BULK_ACTION.HELPDESK_EDIT_TAG_FIELD:
            if (status) {
                return '';
            }
            return 'MSG-KNOW-TOOLTIP-WHEN-DISABLE-HELPDESK-EDIT-TAG-FIELD';
        case Constant.BULK_ACTION.HELPDESK_EXPORT_CSV:
            if (status) {
                return 'MSG-CS-TOOLTIP-WHEN-ENABLE-ICON-EXPORT-CSV';
            }
            return 'MSG-CS-TOOLTIP-WHEN-DISABLE-ICON-EXPORT';
        case Constant.BULK_ACTION.BACK_TO_DRAFT:
            if (status) {
                return '';
            }
            return 'MSG-KNOW-TOOLTIP-DISABLE-BACK-TO-DRAFT';
        case Constant.BULK_ACTION.EDIT_PUBLIC_RANGE:
        case Constant.BULK_ACTION.SENT_TO_PUBLIC:
        case Constant.BULK_ACTION.DUPLICATE:
            return '';
        case Constant.BULK_ACTION.DELETE:
        case Constant.BULK_ACTION.RESTORE:
            if (status) {
                return '';
            }
            return 'MSG-KNOW-TOOLTIP-BULK-ACTION';
        default:
            return '';
    }
}

function BulkActionDropdownHelpDesk({ bulkActionList, handleAction, disableBulkBtn, pendingBulkBtn }) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    const prevOpen = useRef(open);

    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    return (
        <div>
            <Tooltip
                title={`${trI18n('MSG-KNOW-TOOLTIP-BULK-ACTION-1')}`}
                placement="top"
                arrow
            >
                <span>
                    <Button
                        ref={anchorRef}
                        id="composition-button-help-desk"
                        aria-controls={open ? 'composition-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        size="small"
                        variant="contained"
                        endIcon={<ExpandMoreIcon style={{ color: '#2D72D2' }} />}
                        style={{ backgroundColor: '#ECF2FB', color: '#2D72D2', boxShadow: 'none' }}
                        disabled={pendingBulkBtn || disableBulkBtn}
                    >
                        {tr('一括操作')}
                    </Button>
                </span>
            </Tooltip>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: 'bottom right',
                            zIndex: 1000,
                            position: 'absolute',
                            minWidth: '160px'
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    className="composition-menu-root"
                                    aria-labelledby="composition-button-help-desk"
                                    onKeyDown={handleListKeyDown}
                                >
                                    {bulkActionList.map(action => {
                                        return (
                                            <Tooltip
                                                key={action.type}
                                                title={`${trI18n(handleStatusTooltipMsg(action.type, !action.disable))}`}
                                                placement="right-end"
                                                arrow
                                            >
                                                <span>
                                                    <MenuItem
                                                        key={action.type}
                                                        value={action.type}
                                                        disabled={action.disable}
                                                        onClick={e => {
                                                            handleAction(action.type);
                                                            handleClose(e);
                                                        }}
                                                    >
                                                        <p
                                                            style={{ color: action.disable ? '#BABDC5' : '#2E3138' }}
                                                        >
                                                            {trI18n(`${action.type}`)}
                                                        </p>
                                                    </MenuItem>
                                                </span>
                                            </Tooltip>
                                        );
                                    })}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
};

export default BulkActionDropdownHelpDesk;
